import React from 'react';
import { Row, Col, Alert, Button, ControlLabel } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';

export default class PackingBoxNumberEditComponent extends React.Component {

	componentDidMount() {
	}

	render() {
		return (
			<div>
				<Row>
					<Col xs={2} sm={2} md={2}>
						<Button onClick={this.props.editBoxNumber} bsStyle="info">
							Submit
					    </Button>
					</Col>
					<Col xs={10} sm={10} md={10}>
						<Alert bsStyle={this.props.alertStyle}>
							{this.props.alertMessage}
						</Alert>
					</Col>
				</Row>
				<br />
				<Row>
					<Col xs={4} sm={2} md={2}><ControlLabel>職稱</ControlLabel><br />
						{this.props.packingItem.get('firefighterTitle')}</Col>
					<Col xs={4} sm={2} md={2}><ControlLabel>姓名</ControlLabel><br />
						{this.props.packingItem.get('firefighterName')}</Col>
					<Col xs={4} sm={2} md={2}><ControlLabel>產品名稱</ControlLabel><br />
						{this.props.packingItem.get('customerGearName')}</Col>
					<Col xs={4} sm={2} md={2}><ControlLabel>顏色</ControlLabel><br />
						{this.props.packingItem.get('color')}</Col>
					<Col xs={4} sm={2} md={2}><ControlLabel>尺寸</ControlLabel><br />
						{this.props.packingItem.get('sizing')}</Col>
					<Col xs={4} sm={2} md={2}>
						<FieldGroup
							id="boxNumber"
							type="text"
							label="箱號"
							value={this.props.packingItem.get('boxNumber')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.packingItemValidation.get('boxNumber')}
						/>
					</Col>
				</Row>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/PackingBoxNumberEditComponent.jsx